import React, { useState } from "react";
import { FaClipboardList } from "react-icons/fa";
import { useSelector } from "react-redux";
import styles from "../../../pages/schoolCockpit/master/academicConfiguration/Academiclist.module.css";
import { CustomTab } from "../../../components";
import AssessmentList from "./assessment/AssessmentList";
import RemedialAssessmentList from "./remedialAssessment/RemedialAssessmentList";
import StudyMaterialsList from "./studyMaterials/StudyMaterialsList";
import { useLocation } from "react-router-dom";

const AssessmentTab = () => {
  const { translations } = useSelector((state) => state.language);
  const location = useLocation();
  const initialTab = Number(location.state?.activeTab) || 0
  const t = translations?.labels || {};
  const [activeTab, setActiveTab] = useState(initialTab);

  const tabs = [
    {
      label: t.assessment || "Assessment",
      content: <AssessmentList />,
    },
    {
      label: t.remedialAssessment || "Remedial Assessment",
      content: <RemedialAssessmentList />,
    },
    {
      label: t.studyMaterial || "Study Material",
      content: <StudyMaterialsList />,
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.headerIcon}>
          <FaClipboardList />
        </div>
        <h1 className={styles.headerTitle}>
          {t.Assessment || "Assessment"}
        </h1>
      </div>

      <CustomTab
        key={initialTab}
        tabs={tabs}
        defaultActiveTab={initialTab}
        onTabChange={(i) => setActiveTab(i)}
      />
    </div>
  );
};

export default AssessmentTab;